export enum StatisticName {
  verificationCount = 'verification-count',
  registrationCount = 'registration-count',
  clientNationalitiesCount = 'client-nationalities-count',
}

export enum AboutUsStatisticName {
  registeredTrademarks = 'registered-trademarks',
  settledCases = 'settled-cases',
  overcomeOfficeActions = 'overcome-office-actions',
  overcomeOppositions = 'overcome-oppositions',
  coveredCountries = 'covered-countries',
  monitoredCountries = 'monitored-countries',
  teamMembers = 'team-members',
  monthlyWatchHits = 'monthly-watch-hits',
  brandsMonitored = 'brands-monitored',
}

// used on marketign pages, so we do not need to hit the dabatase for either during SSR or static prerender/build
export const APPROX_REGISTERED_TRADEMARKS = '38 000+'
export const APPROX_VERIFIED_TRADEMARKS = '100 000+'
